<template>
  <div>
    <p class="text-secondary font-weight-bold mt-4">
      {{ $t('chargesCalc.tableHeadings.invoiceDetails') }}
    </p>
    <b-card>
      <b-table
        class="text-left calc-table holiday-table"
        bordered
        :items="tableItems"
        :fields="tableFields"
      >
      </b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  props: ['tableItems', 'tableFields']
}
</script>
